import * as React from 'react';
import { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, IconButton, Tooltip } from '@mui/material';
import ModuleSelectorComponent from '__common/components/moduleSelector/moduleSelectorComponent';
import RoofPitchSelector from 'projectDesign/components/RoofPitchSelector';
import ArrayDimensions from 'projectDesign/components/arrayDimensions';
import SetArrayTransparent from 'projectDesign/components/SetArrayTransparent';
import RoofZonesAutofill from 'projectDesign/components/RoofZonesAutofill';
import RoofZonesComponent from '../roofZones/roofZonesComponent';
import RecheckExposureButton from 'projectDesign/components/RecheckExposureButton';
import CustomName from '__common/components/CustomName';
import RowSpacing from 'projectDesign/components/RowSpacing';
import BuildingLengthWidth from 'projectDesign/components/BuildingLengthWidth';
import DesiredTableSize from 'projectDesign/components/DesiredTableSize';
import DesiredTableSizeUla from 'projectDesign/components/DesiredTableSizeUla';
import TableRowSpacingGFT from 'projectDesign/components/TableRowSpacingGFT';
import StructureTypeChange from 'projectDesign/components/StructureTypeChange';
import StructureTypeTilt from 'projectDesign/components/StructureTypeTilt';
import StructureTypeSpanTilt from 'projectDesign/components/StructureTypeSpanTilt';
import LowEdgeToRoof from 'projectDesign/components/LowEdgeToRoof';
import StructureTiltSelector from 'projectDesign/components/StructureTiltSelector';
import PanelsRotation from 'projectDesign/components/PanelsRotation';
import PanelSpacingUpdator from 'projectDesign/components/PanelSpacingUpdator';
import ObstructionsComponent from '../obstructions/ObstructionsComponent';
import { locationAndLoadsPage } from 'projectDesign/components/projectConfiguration/components/locationAndLoadsPage';
import { ProductConfigurationPage } from 'projectDesign/components/projectConfiguration/components/productConfigurationPage';
import { additionalUserInputsPage } from 'projectDesign/components/projectConfiguration/components/additionalUserInputsPage';
import SaveChangesButton from '__common/components/Drawer/components/SaveChangesButton';
import { savePanelsEditor } from '__editor/panelsEditor/components/panels/panels';
import { autoSaveProjectImmediately } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/saveProject';
import { ADDITIONAL_USER_INPUTS_PAGE, LOCATION_AND_LOADS_PAGE, MODULE_SELECTION_PAGE, RAIL_SYSTEM_PAGE } from 'projectDesign/components/projectConfiguration/utils/projectConfigurationDrawerPages';
import smConfig from 'projectDesign/components/projectConfiguration/configurations/SmConfig';
import smTiltConfig from 'projectDesign/components/projectConfiguration/configurations/SmTiltConfig';
import sfConfig from 'projectDesign/components/projectConfiguration/configurations/SfConfig';
import SfmEnhancedConfig from 'projectDesign/components/projectConfiguration/configurations/SfmEnhancedConfig';
import metalXConfig from 'projectDesign/components/projectConfiguration/configurations/MetalXConfig';
import rm5RmDtConfig from 'projectDesign/components/projectConfiguration/configurations/Rm5RmDtConfig';
import gftConfig from 'projectDesign/components/projectConfiguration/configurations/GftConfig';
import ulaConfig from 'projectDesign/components/projectConfiguration/configurations/UlaConfig';
import ascenderConfig from 'projectDesign/components/projectConfiguration/configurations/AscenderConfig';
import ecoFoot2PlusConfig from 'projectDesign/components/projectConfiguration/configurations/ecoFoot2PlusConfig';
import NxtHorizonConfig from 'projectDesign/components/projectConfiguration/configurations/NxtHorizonConfig';
import SMTiltPRConfig from 'projectDesign/components/projectConfiguration/configurations/SmTiltPRConfig';
import { getErrorMessageIfInvalidFactory } from 'projectDesign/components/projectConfiguration/components/getErrorMessageForField';
import { getWarningMessageFactory } from 'projectDesign/components/projectConfiguration/components/getWarningMessageForField';
import {
  products,
  getProductName,
  isSFMFamily,
  isRMFamily,
  isGFT,
  isEcoFoot2Plus,
  isSMTiltPR,
  isAscender,
  isRM5,
  isRM10,
  isRM10Evolution,
  isRMGridFlex,
  isRmGridflex10D,
  isNxtHorizon,
  isAdditionalUserInputEnabledProduct,
} from '__common/constants/products';
import { isBlankMap } from '__common/constants/map';
import {
  adjustableTiltSystem,
  applyPanelRotationFactorChanges,
  applyEcoFoot2PlusRM10andEvoSetbackChanges,
  applyRM5SetbackChanges,
} from '__common/utils/versionCompare/versionCompare';
import { PANEL_SPACINGS_UPDATOR_PERMISSION } from 'user/userGroups';
import { SET_ARRAY_NAME, COPY_PROJECT , SET_PROJECT_MODE, TOGGLE_INPUT_UNIT,} from 'actions';
import { OPEN_CONFIRM_CLEAR_ARRAYS_MODAL } from 'projectDesign/components/confirmClearArraysModal/confirmClearArraysModalActions';
import { roofsSelectorState } from '__editor/components/roofsSelector/roofsSelectorReducer';
import { dispatch, state } from '__common/store';
import { isSolarMount } from '__common/constants/products';
import { UBUILDER_SOFTWARE_GROUP } from 'user/userGroups';
import { validateZipCode } from 'projectDesign/components/projectConfiguration/utils/validation';
import {
  additionalUserInputsPage as additionalUserInputFields,
  allowingZeroValuesInFourthFlyout,
  FIELD_FLYOUT_MAPPING,
} from 'projectDesign/components/projectConfiguration/utils/constants';
import SVG from 'react-inlinesvg';

type SectionId = 'module' | 'location' | 'racking' | 'additional' | 'array' | 'obstructions';
type SectionAccent = 'blue' | 'green' | 'orange' | 'purple' | 'red';

type SectionConfig = {
  id: SectionId;
  title: string;
  icon: string;
  order: number;
};

type OwnProps = {
  productId: string;
  showArraySettings: boolean;
};

type StateProps = {
  moduleSelector: moduleSelectorState;
  projectConfiguration: projectConfigurationState;
  roofsSelector: roofsSelectorState;
  advanceRoofSelecting: advanceRoofSelectingState;
  location: string;
  user: userState;
  getErrorMessageIfInvalid: (fieldName: string) => string | null;
  getWarningMessage: (fieldName: string) => string | null;
  background: backgroundState;
  dimensions: dimensionsState;
  drawingManager: drawingManagerState;
  tiltedRoof: tiltedRoofState;
  mapType: string;
  isStaff: boolean;
  railsProductId: number;
  obstructions: obstructionsState;
};

type Props = OwnProps & StateProps & { dispatch: Function };

function getSectionFromDrawerPage(page: string | null): SectionId | null {
  switch (page) {
    case MODULE_SELECTION_PAGE:
      return 'module';
    case LOCATION_AND_LOADS_PAGE:
      return 'location';
    case RAIL_SYSTEM_PAGE:
      return 'racking';
    case ADDITIONAL_USER_INPUTS_PAGE:
      return 'additional';
    default:
      return null;
  }
}

function getPageConfig(numericProductId: number) {
  switch (numericProductId) {
    case products.solarmount_2:
    case products.solarmount_lt:
    case products.solarmount_hd:
    case products.solarmount_ascender_flush:
      return smConfig;
    case products.solarmount_2_tilt:
    case products.nxt_tilt:
      return smTiltConfig;
    case products.sunframe:
      return sfConfig;
    case products.rm:
    case products.rm_5:
    case products.rm_dt:
    case products.rm_10_ultra:
    case products.rm_gridflex:
    case products.rm_10_evolution:
    case products.rm_gridflex_10d:
    case products.rm_gridflex_5d:
      return rm5RmDtConfig;
    case products.gft:
      return gftConfig;
    case products.ula:
      return ulaConfig;
    case products.metal_x:
      return metalXConfig;
    case products.ecofoot2_plus:
      return ecoFoot2PlusConfig;
    case products.ascender:
      return ascenderConfig;
    case products.nxt_umount:
    case products.nxt_horizon_lt:
    case products.nxt_horizon_hd:
      return NxtHorizonConfig;
    case products.sm_tilt_pr:
    case products.sm_tilt_pr_lt:
    case products.sm_tilt_pr_ascender_rail:
      return SMTiltPRConfig;
    default:
      if (isSFMFamily(numericProductId)) return SfmEnhancedConfig;
      return smConfig;
  }
}


const SectionIconButton: React.FC<{
  id: SectionId;
  icon: string;
title: string;
  isActive: boolean;
  onClick: (id: SectionId) => void;
}> = ({ id, icon, title, isActive, onClick }) => (
  <Tooltip title={title} placement="right">
    <IconButton
      onClick={() => onClick(id)}
      sx={{
        color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.6)',
        width: 48,
        height: 32,
        borderRadius: '6px',
        marginTop:'20px',
        display: 'flex',
        transition: 'all 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          color: '#FFFFFF',
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
        },
        backgroundColor: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
        '& .MuiSvgIcon-root': {
          fontSize: '24px',
        },
        '& .material-icons': {
          fontSize: '30px !important',
        },
        '& svg, & svg path, & svg g': {
          fill: '#FFFFFF',
        },
      }}
    >
      <SVG
  src={icon}
  className={`dsp-sidebar-icon ${isActive ? 'active' : ''}`}
/>
    </IconButton>
  </Tooltip>
);

const DesignSidebarPanel: React.FC<Props> = ({
  productId,
  showArraySettings,
  moduleSelector,
  projectConfiguration,
  roofsSelector,
  advanceRoofSelecting,
  location,
  user,
  getErrorMessageIfInvalid,
  getWarningMessage,
  background,
  dimensions,
  drawingManager,
  tiltedRoof,
  mapType,
  isStaff,
  obstructions,
  dispatch,
}) => {
  const panelEditorActive = !!background.panelEditorActive;
  const [activeSection, setActiveSection] = useState<SectionId | null>(
    panelEditorActive ? 'array' : 'array',
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const hasObstructions = !!(
    background.selectedRoofId &&
    obstructions &&
    obstructions.obstructions &&
    obstructions.obstructions[background.selectedRoofId] &&
    Object.keys(obstructions.obstructions[background.selectedRoofId]).length
  );

  useEffect(() => {
    if (panelEditorActive) {
      setActiveSection('array');
      setDrawerOpen(true);
    }
  }, [panelEditorActive]);
    useEffect(() => {
    if (!advanceRoofSelecting || !advanceRoofSelecting.enabled) return;
    setDrawerOpen(false);
  }, [advanceRoofSelecting && advanceRoofSelecting.enabled]);

useEffect(() => {
  if (panelEditorActive) return;

  const section = getSectionFromDrawerPage(
    projectConfiguration.openedDrawerPage
  );

  if (section) {
    setActiveSection(section);
    setDrawerOpen(true);
  }
}, [projectConfiguration.openedDrawerPage, panelEditorActive]);

  useEffect(() => {
    if (panelEditorActive && activeSection === 'obstructions' && !hasObstructions) {
      setActiveSection('array');
      setDrawerOpen(false);
    }
  }, [panelEditorActive, activeSection, hasObstructions]);

  const handleSectionClick = useCallback((id: SectionId) => {
    if (activeSection === id && drawerOpen) {
      setDrawerOpen(false);
    } else {
      setActiveSection(id);
      setDrawerOpen(true);
    }
  }, [activeSection, drawerOpen]);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || !drawerOpen) {
        return;
      }

      const current = state();
      // These modes already use Escape (cancel scale, measurement, array move, roof draw).
      if (
        (current.scale && current.scale.enabled) ||
        (current.measurementTool && current.measurementTool.enabled) ||
        (current.background && current.background.moveArrayMode) ||
        (current.advanceRoofSelecting && current.advanceRoofSelecting.enabled)
      ) {
        return;
      }

      setDrawerOpen(false);
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [drawerOpen]);

  const handleToggleUnits = useCallback(() => {
  dispatch(TOGGLE_INPUT_UNIT());
}, [dispatch]);
 
  const handleArraySaveChanges = useCallback(() => {
    savePanelsEditor();
    autoSaveProjectImmediately(productId, projectConfiguration.projectId, true);
    setDrawerOpen(false);
  }, [productId, projectConfiguration.projectId]);

  const handleVerify = useCallback(() => undefined, []);

  const { projectId } = projectConfiguration;


  const {
  helioscope_id,
  is_test,
} = projectConfiguration.projectEnvConfig as any;
const handleToggleTestProject = useCallback(() => {
  dispatch(SET_PROJECT_MODE(is_test === 1 ? 0 : 1));
}, [dispatch, is_test]);
  const handleCopyProject = useCallback(() => {
    if (helioscope_id) {
      dispatch(
        OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
          `Confirmation for copy project`,
          `Are you sure that you have gone through the panel editor?`,
          () => {
            dispatch(COPY_PROJECT(projectId));
          },
          null,
          null,
          null,
          'YES',
          'NO',
          { dialogStyle: { opacity: 1 } },
          true,
        ),
      );
    } else {
      dispatch(COPY_PROJECT(projectId));
    }
  }, [dispatch, helioscope_id, projectId]);

  const {
    projectEnvConfig,
    projectVersion,
    envFactorsLoading,
    area,
    inputUnit,
  } = projectConfiguration;

  const { is_aurora_project, is_os_project } = projectEnvConfig as any;
  const shouldAllowCopyProj = !!projectId && !is_aurora_project && !is_os_project;
  const { mapTypeSelected } = roofsSelector;
  const numericProductId = products[productId];
    const showToggleUnits =
  isSolarMount(numericProductId) &&
  user.permissions?.includes(
    UBUILDER_SOFTWARE_GROUP.solarmount_ascender_flush_permission,
  );
  const pageConfig = getPageConfig(numericProductId);

  const locationPage = pageConfig
    ? locationAndLoadsPage(
        pageConfig,
        numericProductId,
        projectEnvConfig,
        mapType,
        location,
        envFactorsLoading,
        area,
        getErrorMessageIfInvalid,
        getWarningMessage,
        false,
      )
    : null;
  const locationContent = locationPage?.content;

  const rackingPage = pageConfig
    ? ProductConfigurationPage(
        pageConfig,
        numericProductId,
        projectEnvConfig,
        mapType,
        location,
        projectVersion,
        getErrorMessageIfInvalid,
        getWarningMessage,
        false,
      )
    : null;
  const rackingContent = rackingPage?.content;

  const shouldShowAdditionalUserInputs = isAdditionalUserInputEnabledProduct(numericProductId) && user.isStaff;
  const additionalInputsPage = pageConfig && shouldShowAdditionalUserInputs
    ? additionalUserInputsPage(
        pageConfig,
        numericProductId,
        projectEnvConfig,
        mapType,
        location,
        envFactorsLoading,
        area,
        getErrorMessageIfInvalid,
        inputUnit,
        moduleSelector.modelData.height,
      )
    : null;
  const additionalUserInputsContent = additionalInputsPage?.content;

  const invalidFields = projectConfiguration.formState?.invalidFields ?? [];
  const hasMappedInvalidField = (page: string) => invalidFields.some(({ fieldName }) => (
    (FIELD_FLYOUT_MAPPING as { [fieldName: string]: string })[fieldName] === page
  ));

  const selectedMfgIsValid = moduleSelector.selectedMfgId !== null
    && moduleSelector.selectedMfgId !== undefined
    && moduleSelector.mfgs.some(({ id }) => id === moduleSelector.selectedMfgId);
  const selectedModelIsValid = moduleSelector.selectedModelId !== null
    && moduleSelector.selectedModelId !== undefined
    && moduleSelector.models.some(({ id }) => id === moduleSelector.selectedModelId);
  const moduleHasInvalidInputs = !selectedMfgIsValid
    || !selectedModelIsValid
    || moduleSelector.modelDataError;

  const locationHasInvalidInputs = Boolean(locationPage?.hasMissingRequiredInputs)
    || !validateZipCode(projectEnvConfig.zipcode)
    || hasMappedInvalidField(LOCATION_AND_LOADS_PAGE);
  const rackingHasInvalidInputs = Boolean(rackingPage?.hasMissingRequiredInputs)
    || hasMappedInvalidField(RAIL_SYSTEM_PAGE);

  const additionalInputFieldNames = additionalUserInputFields(numericProductId);
  const missingAdditionalInputValue = shouldShowAdditionalUserInputs
    && additionalInputFieldNames.some((fieldName) => (
      !allowingZeroValuesInFourthFlyout.includes(fieldName)
      && !(projectEnvConfig as any)[fieldName]
    ));
  const hasAdditionalInvalidField = invalidFields.some(({ fieldName }) => (
    (FIELD_FLYOUT_MAPPING as { [fieldName: string]: string })[fieldName] === ADDITIONAL_USER_INPUTS_PAGE
    || additionalInputFieldNames.includes(fieldName)
  ));
  const additionalHasInvalidInputs = missingAdditionalInputValue || hasAdditionalInvalidField;

  const { selectedRoofId } = background;
  const { ns, ew } = dimensions;
  const is_aurora_os = is_aurora_project || is_os_project;
  const hasExclusiveStaffPermission = user.permissions?.indexOf(PANEL_SPACINGS_UPDATOR_PERMISSION) > -1;

  const getArrayName = () => {
    if (!selectedRoofId || !drawingManager.roofs?.[selectedRoofId]) return '';
    return drawingManager.roofs[selectedRoofId].roofName;
  };

  const setArrayName = (arrayName: string) => {
    dispatch(SET_ARRAY_NAME(arrayName, selectedRoofId));
  };

  const renderArrayContent = () => {
    switch (numericProductId) {
      case products.solarmount_2:
      case products.solarmount_hd:
      case products.solarmount_lt:
      case products.solarmount_ascender_flush:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {hasExclusiveStaffPermission && <PanelSpacingUpdator />}
            {!is_aurora_os && <><SetArrayTransparent /><RoofZonesAutofill /></>}
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.solarmount_2_tilt:
      case products.nxt_tilt:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            {adjustableTiltSystem(projectVersion) && <RoofPitchSelector />}
            <SetArrayTransparent />
            <RoofZonesAutofill />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.sunframe:
      case products.sfmEnhanced:
      case products.sfmInfinity:
      case products.metal_x:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            <SetArrayTransparent />
            <RoofZonesAutofill />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_5:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            {isBlankMap(mapType) && applyRM5SetbackChanges(projectVersion) && <BuildingLengthWidth />}
            <RowSpacing productId={numericProductId} />
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {isBlankMap(mapType) && applyEcoFoot2PlusRM10andEvoSetbackChanges(products.rm, projectVersion) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_dt:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_10_evolution:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            {isBlankMap(mapType) && applyEcoFoot2PlusRM10andEvoSetbackChanges(products.rm_10_evolution, projectVersion) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            {hasExclusiveStaffPermission && <PanelSpacingUpdator />}
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_gridflex:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            <RowSpacing productId={numericProductId} />
            {isBlankMap(mapType) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_gridflex_10d:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            <RowSpacing productId={numericProductId} />
            {isBlankMap(mapType) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            {hasExclusiveStaffPermission && <PanelSpacingUpdator />}
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_gridflex_5d:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector productId={numericProductId} />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            <RowSpacing productId={numericProductId} />
            {isBlankMap(mapType) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            {hasExclusiveStaffPermission && <PanelSpacingUpdator />}
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.rm_10_ultra:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.ecofoot2_plus:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            {isBlankMap(mapType) && applyEcoFoot2PlusRM10andEvoSetbackChanges(products.ecofoot2_plus, projectVersion) && <BuildingLengthWidth />}
            <SetArrayTransparent />
            <RoofPitchSelector />
            {applyPanelRotationFactorChanges(projectVersion) && isStaff && <PanelsRotation />}
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.gft:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <SetArrayTransparent />
            <DesiredTableSize />
            {drawingManager.roofs?.[selectedRoofId]?.tableRowSpacing !== 0 && <TableRowSpacingGFT />}
            <ArrayDimensions ns={ns} ew={ew} />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.ula:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <SetArrayTransparent />
            <DesiredTableSizeUla />
            <ArrayDimensions ns={ns} ew={ew} />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.ascender:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <SetArrayTransparent />
            <StructureTypeChange />
            <StructureTypeTilt />
            <StructureTypeSpanTilt />
            <LowEdgeToRoof />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.nxt_umount:
      case products.nxt_horizon_lt:
      case products.nxt_horizon_hd:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            {!is_aurora_os && <><SetArrayTransparent /><RoofZonesAutofill /></>}
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      case products.sm_tilt_pr:
      case products.sm_tilt_pr_lt:
      case products.sm_tilt_pr_ascender_rail:
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <StructureTiltSelector productId={numericProductId} />
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );

      default:
        if (isSFMFamily(numericProductId)) {
          return (
            <div className="dsp-array-fields">
              <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
              <RoofPitchSelector />
              <SetArrayTransparent />
              <RoofZonesAutofill />
              <ArrayDimensions ns={ns} ew={ew} />
              <RoofZonesComponent />
              <RecheckExposureButton />
            </div>
          );
        }
        return (
          <div className="dsp-array-fields">
            <CustomName onChange={setArrayName} value={getArrayName()} placeHolder="Array name" />
            <RoofPitchSelector />
            <SetArrayTransparent />
            <ArrayDimensions ns={ns} ew={ew} />
            <RoofZonesComponent />
            <RecheckExposureButton />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </div>
        );
    }
  };

  const getSectionTitle = () => {
    switch (activeSection) {
      case 'array':
        return 'Array Settings';
      case 'module':
        return 'Module';
      case 'location':
        return 'Location & Loads';
      case 'racking':
        return 'Racking';
      case 'additional':
        return 'Additional Inputs';
      case 'obstructions':
        return 'Obstructions';
      default:
        return 'Design Inputs';
    }
  };

  const getSectionContent = () => {
    switch (activeSection) {
      case 'array':
        return showArraySettings && selectedRoofId ? renderArrayContent() : null;
      case 'module':
        return (
          <>
            <ModuleSelectorComponent productId={productId} designSidebar />
            <SaveChangesButton
              designSidebar
              disabled={moduleHasInvalidInputs}
              disabledReason="Select a valid manufacturer and model, then correct the highlighted module inputs before verifying."
              onClick={handleVerify}
              page={MODULE_SELECTION_PAGE}
              verifiedFlyouts={projectConfiguration.verifiedFlyouts}
            />
          </>
        );
      case 'location':
        return (
          <>
            {locationContent}
            <SaveChangesButton
              designSidebar
              disabled={locationHasInvalidInputs}
              onClick={handleVerify}
              page={LOCATION_AND_LOADS_PAGE}
              verifiedFlyouts={projectConfiguration.verifiedFlyouts}
            />
          </>
        );
      case 'racking':
        return (
          <>
            {rackingContent}
            <SaveChangesButton
              designSidebar
              disabled={rackingHasInvalidInputs}
              onClick={handleVerify}
              page={RAIL_SYSTEM_PAGE}
              verifiedFlyouts={projectConfiguration.verifiedFlyouts}
            />
          </>
        );
      case 'additional':
        return shouldShowAdditionalUserInputs ? (
          <>
            {additionalUserInputsContent}
            <SaveChangesButton
              designSidebar
              disabled={additionalHasInvalidInputs}
              onClick={handleVerify}
              page={ADDITIONAL_USER_INPUTS_PAGE}
              verifiedFlyouts={projectConfiguration.verifiedFlyouts}
            />
          </>
        ) : null;
      case 'obstructions':
        return showArraySettings && hasObstructions ? (
          <>
            <ObstructionsComponent />
            <SaveChangesButton onClick={handleArraySaveChanges} />
          </>
        ) : null;
      default:
        return null;
    }
  };

  const designDrawerSectionClass =
    !panelEditorActive && activeSection
      ? `dsp-drawer--${activeSection}`
      : '';

  const panelDrawerSectionClass =
    panelEditorActive && activeSection
      ? `dsp-drawer-panel--${activeSection}`
      : '';

  return (
    <Box className="dsp-sidebar">
      <Box className="dsp-icon-bar">
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {panelEditorActive && selectedRoofId && (
            <SectionIconButton
              id="array"
              icon={require("assets/media/icons/sidebar_pitch.svg")}
              title="Array Settings"
              isActive={activeSection === 'array' && drawerOpen}
              onClick={handleSectionClick}
            />
          )}
         {!panelEditorActive && (<><SectionIconButton
            id="module"
             icon={require('assets/media/icons/sidebar_module.svg')}
            title="Module"
            isActive={activeSection === 'module' && drawerOpen}
            onClick={handleSectionClick}
          />
          <SectionIconButton
            id="location"
            icon={require('assets/media/icons/sidebar_location.svg')}
            title="Location & Loads"
            isActive={activeSection === 'location' && drawerOpen}
            onClick={handleSectionClick}
          />
          <SectionIconButton
            id="racking"
            icon={require('assets/media/icons/sidebar_racking.svg')}
            title="Racking"
            isActive={activeSection === 'racking' && drawerOpen}
            onClick={handleSectionClick}
          /></>)}
          {!panelEditorActive && shouldShowAdditionalUserInputs && (
            <SectionIconButton
              id="additional"
              icon={require('assets/media/icons/additional_user_inputs.svg')}
              title="Additional Inputs"
              isActive={activeSection === 'additional' && drawerOpen}
              onClick={handleSectionClick}
            />
          )}
          {panelEditorActive && hasObstructions && (
            <SectionIconButton
              id="obstructions"
              icon={require('assets/media/icons/icon_town.svg')}
              title="Obstructions"
              isActive={activeSection === 'obstructions' && drawerOpen}
              onClick={handleSectionClick}
            />
          )}
      { !panelEditorActive && (    <button
  type="button"
  className="dsp-icon-bar__action-btn"
  onClick={handleToggleTestProject}
  title={is_test === 1 ? 'Remove Test Project' : 'Mark Test Project'}
>
  <i
    className="material-icons"
    style={{
      color: is_test === 1 ? '#ff9800' : '#ffffff',
        width: "30px",
  height: "30px",
  marginTop:"16px"

    }}
  >

  new_releases

  </i>
</button> )}
      </Box>
        {!panelEditorActive && showToggleUnits && (
  <Tooltip title="Toggle Units" placement="right">
    <button
      type="button"
      className="dsp-icon-bar__action-btn"
      onClick={handleToggleUnits}
    >
     <SVG
  src={require('assets/media/icons/icon_metrics.svg')}
  className="dsp-metrics-icon"
/>
    </button>
  </Tooltip>
)}
        <Box className="dsp-icon-bar__footer">
          {!panelEditorActive && shouldAllowCopyProj && (
            <button
              type="button"
              className="dsp-icon-bar__action-btn"
              onClick={handleCopyProject}
              title="Copy Project"
            >
              <i className="material-icons">content_copy</i>
            </button>
          )}
        </Box>

      </Box>

      <Box
        className={
          panelEditorActive
            ? `dsp-drawer-panel ${panelDrawerSectionClass} ${drawerOpen ? '' : 'dsp-drawer-panel--collapsed'}`
            : `dsp-drawer ${designDrawerSectionClass} ${drawerOpen ? '' : 'dsp-drawer--collapsed'}`
        }
      >
        <Box className={panelEditorActive ? 'dsp-drawer__body_in_panel_edit' : 'dsp-drawer__body'}>
          {getSectionContent()}
        </Box>
      </Box>
    </Box>
  );
};

function mapStateToProps(state: appState): StateProps {
  return {
    moduleSelector: state.moduleSelector,
    projectConfiguration: state.projectConfiguration,
    roofsSelector: state.roofsSelector,
    advanceRoofSelecting: state.advanceRoofSelecting,
    location: state.roofsSelectorMap.location,
    user: state.user,
    getErrorMessageIfInvalid: getErrorMessageIfInvalidFactory(state),
    getWarningMessage: getWarningMessageFactory(state),
    background: state.background,
    dimensions: state.dimensions,
    drawingManager: state.drawingManager,
    tiltedRoof: state.tiltedRoof,
    mapType: state.roofsSelector.mapType,
    isStaff: state.user.isStaff,
    railsProductId: state.projectConfiguration.railsProductId,
    obstructions: state.obstructions,
  };
}

export default connect(mapStateToProps)(DesignSidebarPanel);
